import { analyticsClient } from '../../client/analytics';

export default function getShareFormData(playbookTitle) {
  return {
    pages: [
      {
        elements: [
          {
            type: 'title',
            label: 'Share this conversion secret',
          },
          {
            type: 'share-options',
            label: '',
            onSubmit: (shareOption) =>
              analyticsClient.track('[Website] Playbook share', {
                playbook: playbookTitle,
                share_option: shareOption,
              }),
          },
        ],
      },
    ],
  };
}
